import { reactive, computed } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import { useRouter } from '@berlin-front/common/composables/useRouter';
import { ApiCacheContext } from '@services/ApiCacheContext';
import { notNil } from '@berlin-front/common/utils';
import { AtoneMemberTypePostResponseMemberTypeEnum } from '@netprotections/berlin-bff';
import { ROUTE_NAME } from '@/router/route-name';
import { AtoneAuthIntroType } from './context';

const SERVICE_DESCRIPTION_URL = process.env.VUE_APP_NP_ATOBARAI_ATONE_SERVICE_URL;

export default {
  useIntro: () => {
    const router = useRouter();

    // APIの呼び出しキャッシュから目会員種別を取得する。
    const { atoneMemberTypePostResult } = useContext(ApiCacheContext);
    /**
     * メンバー種別
     */
    const memberType = computed(() => notNil(atoneMemberTypePostResult.value?.memberType));

    // アクション定義
    /**
     * ログイン画面へ遷移するアクション
     */
    const goToAtoneauthLogin = async () => {
      await router.replace({ name: ROUTE_NAME.ATONEAUTH_BY_ATONE_MEMBER });
    };

    /**
     * NP会員のAtone登録へ遷移するアクション
     */
    const goToAtoneauthRegisterNpAccount = async () => {
      await router.replace({ name: ROUTE_NAME.ATONEAUTH_BY_NP_MEMBER });
    };

    /**
     * Atone会員登録へ遷移するアクション
     */
    const goToAtoneauthRegisterAccount = () => {
      if (memberType.value === AtoneMemberTypePostResponseMemberTypeEnum.NUMBER_3) {
        // 仮会員のケース
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        router.replace({ name: ROUTE_NAME.ATONEAUTH_GUEST_MEMBER_REGISTER });
      } else {
        // 仮会員以外のケース
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        router.replace({ name: ROUTE_NAME.ATONEAUTH_MEMBER_REGISTER });
      }
    };

    return reactive({
      memberType,
      SERVICE_DESCRIPTION_URL,
      goToAtoneauthLogin,
      goToAtoneauthRegisterNpAccount,
      goToAtoneauthRegisterAccount,
    });
  },
} satisfies AtoneAuthIntroType;
